'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _immutable = require('immutable');

var _getUsageTracker = require('pricing-pages-unified-ui/utils/getUsageTracker');

var _getUsageTracker2 = _interopRequireDefault(_getUsageTracker);

var _UIAdminOnlyWrapper = require('ui-addon-upgrades/decorators/UIAdminOnlyWrapper');

var _UIAdminOnlyWrapper2 = _interopRequireDefault(_UIAdminOnlyWrapper);

var _AdminModalTypes = require('ui-addon-upgrades/_core/common/constants/AdminModalTypes');

var _AdminTypes = require('ui-addon-upgrades/_core/common/constants/AdminTypes');

var _UIAlert = require('UIComponents/alert/UIAlert');

var _UIAlert2 = _interopRequireDefault(_UIAlert);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _QuoteApi = require('../../api/QuoteApi');

var _urls = require('../../utils/urls');

var _getRelevantQuote = require('../../utils/getRelevantQuote');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ActiveQuoteBanner = function (_Component) {
  _inherits(ActiveQuoteBanner, _Component);

  function ActiveQuoteBanner() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ActiveQuoteBanner);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActiveQuoteBanner.__proto__ || Object.getPrototypeOf(ActiveQuoteBanner)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      activeQuotes: (0, _immutable.List)(),
      currentState: 'INITIAL'
    }, _this.handleViewQuote = function () {
      _this.trackBannerInteraction('view-active-quote-banner');
    }, _this.handleClickQuote = function (relevantQuote) {
      _this.trackBannerInteraction('click-active-quote-banner');
      (0, _urls.handleRedirect)((0, _urls.getActiveQuoteUrl)(relevantQuote.get('id')));
    }, _this.handleDismiss = function () {
      _this.trackBannerInteraction('dismiss-active-quote-banner');
      _this.setState({ currentState: 'DISMISSED' });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ActiveQuoteBanner, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.isMounted_ = true;
      (0, _QuoteApi.fetchActiveQuotes)().then(function (activeQuotes) {
        if (!_this2.isMounted_) return;
        _this2.setState({ currentState: 'SUCCESS', activeQuotes: activeQuotes });
        _this2.handleViewQuote();
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.isMounted_ = false;
    }
  }, {
    key: 'trackBannerInteraction',
    value: function trackBannerInteraction(name) {
      (0, _getUsageTracker2.default)().track('bannerInteraction', { name: name });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          activeQuotes = _state.activeQuotes,
          currentState = _state.currentState;

      if (currentState !== 'SUCCESS') return null;
      var relevantQuote = (0, _getRelevantQuote.getRelevantQuote)(activeQuotes, this.props.hub);
      if (!relevantQuote) return null;
      return _react2.default.createElement(
        'div',
        { className: 'm-bottom-4', 'data-selenium-id': 'active-quote-banner' },
        _react2.default.createElement(
          _UIAlert2.default,
          {
            type: 'info',
            titleText: _react2.default.createElement(_FormattedMessage2.default, { message: 'activeQuote.title' })
          },
          _react2.default.createElement(_FormattedMessage2.default, { message: 'activeQuote.text' }),
          _react2.default.createElement(
            _UIAdminOnlyWrapper2.default,
            {
              adminType: _AdminTypes.BILLING,
              modalType: _AdminModalTypes.REQUEST_QUOTE,
              quoteLink: (0, _urls.getActiveQuoteUrl)(relevantQuote.get('id'))
            },
            _react2.default.createElement(
              _UIButton2.default,
              {
                className: 'm-left-4',
                use: 'tertiary',
                size: 'small',
                onClick: function onClick() {
                  for (var _len2 = arguments.length, partialArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    partialArgs[_key2] = arguments[_key2];
                  }

                  return _this3.handleClickQuote.apply(_this3, [relevantQuote].concat(partialArgs));
                },
                'data-selenium-id': 'active-quote-purchase-button'
              },
              _react2.default.createElement(_FormattedMessage2.default, { message: 'activeQuote.link' })
            )
          ),
          _react2.default.createElement(
            _UIButton2.default,
            {
              className: 'm-left-4',
              use: 'tertiary-light',
              size: 'small',
              onClick: this.handleDismiss
            },
            _react2.default.createElement(_FormattedMessage2.default, { message: 'activeQuote.dismiss' })
          )
        )
      );
    }
  }]);

  return ActiveQuoteBanner;
}(_react.Component);

exports.default = ActiveQuoteBanner;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/banners/ActiveQuoteBanner.js
// module id = 729
// module chunks = 3 4